import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvService {

  // The values that are defined here are the default values that can
  // be overridden by env.js

  // API url
  public host = '';
  // SECURITY: must point to the public HTTPS API gateway, NOT an internal IP (fixes internal-IP exposure + plaintext HTTP). Confirm the gateway routes to the API before deploying.
  public apiUrl = 'https://api.ag.lgvina.vn/';
  public provincesUrl = 'https://provinces.open-api.vn/'; 
  // public mwiToken='';
  // public terminalID = ''; 
  // public merchantID ='';
  // public printDelay =''; 
  // public bankTerminalCOM ='';
  // public barcodeLogin = false;
  // public defaultLogin = "CustomCode";
  
  // Whether or not to enable debug mode
  public enableDebug = false;

  constructor() {
  }
}
